import React from 'react';

const HorizontalImageCarousel = () => {
  // Images with labels from images folder
  const imageData = [
    { image: '/images/img1.jpg', label: 'austin' },
    { image: '/images/img2.jpg', label: 'bangalore' },
    { image: '/images/img3.jpg', label: 'beijing' },
    { image: '/images/img4.jpg', label: 'boston' },
    { image: '/images/img5.jpg', label: 'guangzhou' },
    { image: '/images/img6.jpg', label: 'hong-kong' },
    { image: '/images/img7.jpg', label: 'london' },
    { image: '/images/img8.jpg', label: 'los-angeles' },
    { image: '/images/img9.jpg', label: 'nashville' },
    { image: '/images/img10.jpg', label: 'new-york' },
];

  // Duplicate images for seamless loop
  const duplicatedImages = [...imageData, ...imageData, ...imageData];

  return (
    <div className="w-full bg-[#FFFFFF] overflow-hidden">
        <style>{`
        @keyframes scroll-smooth {
          0% {
            transform: translate3d(0, 0, 0);
          }
          100% {
            transform: translate3d(-50%, 0, 0);
          }
        }

        .animate-scroll-smooth {
          display: flex;
          width: max-content;
          animation: scroll-smooth 40s linear infinite;
          will-change: transform;
          /* Force GPU layer for the track itself */
          transform: translateZ(0);
        }
      `}</style>
        {/* <div className="space-y-3 text-center mx-auto w-full mb-10">
                <AnimatedSection className='fade-up'>
                <h2 className="text-4xl md:text-5xl font-semibold text-white mb-6">
                  Newsletters
                </h2>
                </AnimatedSection>
            </div> */}
      <div className="relative">
        <div className="flex animate-scroll-left cursor-pointer">
          {duplicatedImages.map((item, index) => (
            // CHANGE: 'div' ko 'a' tag se replace kiya hai
            <a
              key={index}
              className="flex-shrink-0 relative w-full md:w-[50vw] lg:w-[60vw] h-96 lg:h-[500px] overflow-hidden group block"
            >
              <img
                src={item.image}
                alt={item.label || "Newsletter"}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
              />
              
              <div className="absolute inset-0 bg-[#2a3890]/40 group-hover:bg-transparent transition-all duration-300 pointer-events-none mix-blend-multiply"></div>
              
              {/* Label Overlay - Sirf tab dikhayein agar label majood ho */}
              {/* {item.label && (
                <div 
                    className="z-10 carousel-label"
                    style={{
                    position: 'absolute',
                    backgroundColor: "#fff42d",
                    bottom: '20px',
                    left: '0',
                    right: '0',
                    margin: '0 auto',
                    borderRadius: '8px',
                    padding: '6px 10px 4px',
                    color: 'black',
                    fontWeight: '900',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    width: 'fit-content'
                    }}
                >
                    {item.label}
                </div>
              )} */}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalImageCarousel;
